import { render, staticRenderFns } from "./MarqeenContainer.vue?vue&type=template&id=479882ff&"
import script from "./MarqeenContainer.vue?vue&type=script&lang=js&"
export * from "./MarqeenContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports